<template>
  <div v-if="pages > 1" class="pagination-listing m-top-5">
    <div class="pagination-listing__wrap">
      <div class="pagination-listing__pages text-medium">
        <NuxtLink
          v-for="p in pages"
          :key="p"
          :to="{
            query: {
              ...route.query,
              page: p,
            },
          }"
          class="pagination-listing__page"
          :class="{ '--active': p === page }"
        >
          {{ p }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  pages: Number,
})
const route = useRoute()
const page = ref(
  route.query?.page && route.query?.page ? parseInt(route.query.page) : 1,
)

watch(
  () => route.query,
  (query) => {
    if (query.page) {
      page.value = parseInt(query.page)
    }
  },
)
</script>

<script>
export default {
  name: 'ListingPagination',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
